/** Bridge-style suit names (lowest index = weakest tiebreak, highest = strongest). */
export const SUIT_NAMES = ['Clubs', 'Diamonds', 'Hearts', 'Spades'];

export const RANK_NAMES = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'Jack', 'Queen', 'King', 'Ace'];

/** Standard playing-card rank letters (face cards + ace). Numeric ranks unchanged. */
export const RANK_SHORT = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];

/** Suit order for display: strongest first (standard bridge / high-card tiebreak). */
export const SUIT_RANKING_DISPLAY = ['Spades', 'Hearts', 'Diamonds', 'Clubs'];

/**
 * Card id: rank 0–12 (2→Ace) in suit bucket; suit 0–3 Clubs→Spades.
 * id = suitIndex * 13 + rankIndex — higher id ⇒ stronger card for same rank ordering... wait
 * We use: suit = floor(id/13), rank = id%13 — then compare rank first then suit.
 */
export function cardIdToLabel(id) {
  if (id == null || Number.isNaN(id)) return '';
  const rank = id % 13;
  const suit = Math.floor(id / 13);
  return `${RANK_NAMES[rank]} of ${SUIT_NAMES[suit]}`;
}

export function cardIdToSymbol(id) {
  if (id == null || Number.isNaN(id)) return '';
  const suit = Math.floor(id / 13);
  return ['♣', '♦', '♥', '♠'][suit];
}

/** Compact label for large displays, e.g. "Q♠". */
export function cardIdToShortLabel(id) {
  if (id == null || Number.isNaN(id)) return '';
  const rank = id % 13;
  return `${RANK_SHORT[rank]}${cardIdToSymbol(id)}`;
}

export function cardIdIsRed(id) {
  const suit = Math.floor(id / 13);
  return suit === 1 || suit === 2;
}

/** Positive if a beats b (higher rank wins; same rank ⇒ higher suit index wins). */
export function compareCardIds(a, b) {
  const ra = a % 13;
  const sa = Math.floor(a / 13);
  const rb = b % 13;
  const sb = Math.floor(b / 13);
  if (ra !== rb) return ra - rb;
  return sa - sb;
}

export function createShuffledDeck() {
  const deck = Array.from({ length: 52 }, (_, i) => i);
  for (let i = deck.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [deck[i], deck[j]] = [deck[j], deck[i]];
  }
  return deck;
}
